import { modifierContext } from 'pages/Merchant/Item/ModifierProvider';
import React, { useContext, useEffect, useMemo } from 'react';
import {
  Box,
  Divider,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { env } from 'constants';
import OptionRow from './OptionRow';

function ItemSizes({ item, value, onChange }) {
  const { loading } = useContext(modifierContext);

  const sizes = useMemo(
    () => {
      if (!item.sizes) {
        return [];
      }
      return item.sizes
        .filter((t) => t.marked_up_price)
        .map(({
          serving_size: servingSize,
          marked_up_price: price, discounted_marked_up_price: discountedPrice, id, name, position,
        }) => ({
          price,
          id,
          title: name,
          position,
          discountedPrice,
          servingSize: env.IS_CATERING && servingSize,
        }));
    },
    [item],
  );

  useEffect(() => {
    if ((!value || !sizes.some((s) => s.position === value)) && sizes[0]) {
      onChange(sizes[0].position);
    }
  }, [value, sizes]);

  if (sizes.length < 2) {
    return null;
  }

  if (loading) {
    return null;
  }

  return (
    <Box>
      <Typography gutterBottom variant="title-lg">
        Select Size
      </Typography>

      <RadioGroup>
        {sizes.map((size) => (
          <OptionRow option={size} key={size.position}>
            <Radio
              checked={value === size.position}
              onChange={() => onChange(size.position)}
              data-testid={`item-size-${size.position}`}
            />
          </OptionRow>
        ))}
      </RadioGroup>
      <Divider sx={{ mt: 1, mb: 2 }} />
    </Box>
  );
}

export default ItemSizes;
